import { render, staticRenderFns } from "./upLoadImg.vue?vue&type=template&id=836f96f4&"
import script from "./upLoadImg.vue?vue&type=script&lang=js&"
export * from "./upLoadImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports